// extracted by mini-css-extract-plugin
module.exports = {"mobileInput":"DatePicker_mobileInput__7WHyD","wrapper":"DatePicker_wrapper__-VzPz","icon":"DatePicker_icon__1QURS"};